import { usePopup } from '@contexts/popupContext';
import { Loader } from '@shared/designSystem/Loader';
import styles from '@styles/components/Novedades/ConfirmarNovedad.module.css';
import { useState } from 'react';

// import '@styles/Debugging.css'
import ResultPopup from '@components/General/ResultPopup';
import { Application } from '@core/Application';
import { ConfirmNovedadRequest, NovedadesService } from '@services/NovedadesService';


const ConfirmarNovedad = ({ row, onDone, orgID, colaborador, fecha, novedad }) => {
    const {hidePopup, showPopup} = usePopup()
    const [loading, setLoading] = useState(false)


    const handleConfirmarNovedad = async () => {
        const data: ConfirmNovedadRequest = {
            novedad: novedad.name,
            novedadAcronym: novedad.acronym
        };
        
        setLoading(true)
        try {
            const novedadesService = Application.shared().coreDependencies.novedadesService;
            await novedadesService.changeNovedadForInasistencia(orgID, row.id, data);
            
            showPopup(() => <ResultPopup result={"Novedad asignada correctamente!"} succesful={true}/>)
            onDone()
        } catch (error) {
            showPopup(() => <ResultPopup result={"Error al guardar novedad"} succesful={false}/>)
            console.error(error)
        }
        setLoading(false)
    }
    

    return (
        <div className={styles['popup']}>
            <div className={styles['title']}>Confirmar Novedad</div>
            <div className={styles['data-grid']}>
                <p className={styles['grid-text']}>Colaborador</p>
                <p className={styles['grid-text-data']}>{colaborador}</p>

                <p className={styles['grid-text']}>Fecha</p>
                <p className={styles['grid-text-data']}>{fecha}</p>

                <p className={styles['grid-text']}>Novedad</p>
                <p className={styles['grid-text-data']}>{novedad.name}</p>
            </div>

            <div className={styles['bottom-container']}>
                    <div className={`${styles['button']} ${styles['cancelar']}`} onClick={() => hidePopup()}>
                        Cancelar
                    </div>

                    <div className={`${styles['button']} ${styles['agregar']}`} onClick={handleConfirmarNovedad}>
                        {!loading ? 'Guardar'
                        :
                        <div className={styles['no-qontact-points']}>
                            <Loader height="32px" width="32px" />
                        </div>
                        }
                    </div>
            </div>

        </div>
    )
}

export default ConfirmarNovedad
